/*! CyberData IP-PBX List - version 2026-10-14 */
/* "Connecting to Compatible IP-PBX Servers" on cyberdata.net. The list comes from window.CD_PBX,
   published from the CyberData intranet (Shopify tab) to files.cyberdata.net.
   Same file is used by the intranet preview. Everything is scoped under #cd-pbx. */
(function () {
  var root = document.getElementById("cd-pbx");
  if (!root) return;

  var ICON = {
    doc: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M8 13h8M8 17h5"/></svg>',
    ext: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 4h6v6M20 4l-9 9"/><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>',
    page: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>',
    video: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2" y="6" width="14" height="12" rx="2"/><path d="m16 10 6-3v10l-6-3"/></svg>',
    novideo: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.7 6H14a2 2 0 0 1 2 2v3.3l1 1 5-3v10M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2M2 2l20 20"/></svg>',
    search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'
  };
  var VIDEO = { "true": ["video", "Supports h.264 video"], "false": ["novideo", "Does not support h.264 video"] };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  var site = root.getAttribute("data-site") || "";   // intranet preview: https://www.cyberdata.net
  var staged = window.CD_STAGED || {};                // intranet preview: files not published yet
  function href(u) {
    if (staged[u]) return staged[u];
    return u.charAt(0) === "/" ? site + u : u;
  }
  function safe(u) { return /^(https?:\/\/|\/)/i.test(u); }
  function kindOf(u) {
    if (/\.(pdf|zip|docx?)(\?|#|$)/i.test(u)) return "doc";
    if (u.charAt(0) === "/" || /^https?:\/\/(www\.)?cyberdata\.net\//i.test(u)) return "page";
    return "ext";
  }
  function link(text, u) {
    var k = kindOf(u), out = k !== "page";
    return '<a class="cdp-' + k + '" href="' + esc(href(u)) + '"' + (out ? ' target="_blank" rel="noopener"' : "") + ">" +
      ICON[k] + "<span>" + esc(text) + "</span></a>";
  }
  // Text lines may hold [label](url) links; everything else is plain text.
  function rich(t) {
    var out = "", re = /\[([^\]]+)\]\(([^)\s]+)\)/g, last = 0, m;
    while ((m = re.exec(t))) {
      out += esc(t.slice(last, m.index));
      out += safe(m[2]) ? '<a href="' + esc(href(m[2])) + '" target="_blank" rel="noopener">' + esc(m[1]) + "</a>" : esc(m[0]);
      last = re.lastIndex;
    }
    return out + esc(t.slice(last));
  }
  function items(list) {
    var html = "", inList = false;
    (list || []).forEach(function (i) {
      if (i.t === "link") {
        if (!inList) { html += '<ul class="cdp-links">'; inList = true; }
        html += "<li>" + (safe(i.url) ? link(i.text, i.url) : esc(i.text)) + "</li>";
        return;
      }
      if (inList) { html += "</ul>"; inList = false; }
      html += i.t === "heading" ? '<h4 class="cdp-h">' + esc(i.text) + "</h4>" : '<p class="cdp-t">' + rich(i.text) + "</p>";
    });
    return html + (inList ? "</ul>" : "");
  }
  function slug(s, i) { return "pbx-" + (String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || i); }

  function render(data) {
    var systems = data.systems || [];
    var cards = systems.map(function (s, i) {
      var logos = (s.logos || []).filter(function (l) { return safe(l.src); }).map(function (l) {
        var img = '<img src="' + esc(href(l.src)) + '" alt="' + esc(s.name) + ' logo" loading="lazy">';
        return l.url && safe(l.url) ? '<a href="' + esc(href(l.url)) + '" target="_blank" rel="noopener">' + img + "</a>" : img;
      }).join("");
      var v = VIDEO[String(s.video)];
      var badge = v ? '<span class="cdp-badge cdp-' + v[0] + '" title="' + v[1] + '">' + ICON[v[0]] + "<span>" + v[1] + "</span></span>" : "";
      return '<article class="cdp-card" id="' + slug(s.name, i) + '" data-i="' + i + '">' +
        '<div class="cdp-logos">' + logos + "</div>" +
        '<div class="cdp-body"><div class="cdp-head"><h3>' + esc(s.name) + "</h3>" + badge + "</div>" + items(s.items) + "</div></article>";
    }).join("");
    var jump = systems.map(function (s, i) { return '<option value="' + slug(s.name, i) + '">' + esc(s.name) + "</option>"; }).join("");

    root.innerHTML =
      (data.intro && data.intro.length ? '<div class="cdp-intro">' + items(data.intro) + "</div>" : "") +
      '<div class="cdp-legend" aria-label="Legend">' +
      '<span class="cdp-badge cdp-video">' + ICON.video + "<span>Supports h.264 video</span></span>" +
      '<span class="cdp-badge cdp-novideo">' + ICON.novideo + "<span>Does not support h.264 video</span></span></div>" +
      (data.caption ? '<p class="cdp-caption">' + esc(data.caption) + "</p>" : "") +
      '<div class="cdp-bar">' +
      '<label class="cdp-search">' + ICON.search + '<input type="search" id="cdp-q" placeholder="Search phone systems and guides" autocomplete="off" aria-label="Search phone systems and guides"></label>' +
      '<label class="cdp-check"><input type="checkbox" id="cdp-v"> Supports h.264 video</label>' +
      '<label class="cdp-ctl"><span>Jump to</span><select id="cdp-j"><option value="">Choose a system…</option>' + jump + "</select></label>" +
      '<span class="cdp-count" id="cdp-count" aria-live="polite"></span></div>' +
      '<div class="cdp-list" id="cdp-list">' + cards + "</div>" +
      '<p class="cdp-none" id="cdp-none" hidden>No phone systems match. Please contact VoIP Technical Support about systems that are not listed.</p>';

    var q = root.querySelector("#cdp-q"), vid = root.querySelector("#cdp-v"), jumpSel = root.querySelector("#cdp-j");
    var cardsEl = Array.prototype.slice.call(root.querySelectorAll(".cdp-card"));
    var hay = systems.map(function (s) {
      return (s.name + " " + (s.items || []).map(function (i) { return i.text; }).join(" ")).toLowerCase();
    });
    function apply() {
      var words = q.value.toLowerCase().split(/\s+/).filter(Boolean), shown = 0;
      cardsEl.forEach(function (c, i) {
        var ok = words.every(function (w) { return hay[i].indexOf(w) >= 0; }) && (!vid.checked || systems[i].video === true);
        c.hidden = !ok;
        if (ok) shown++;
      });
      root.querySelector("#cdp-count").textContent = shown === systems.length ? systems.length + " phone systems" : shown + " of " + systems.length + " phone systems";
      root.querySelector("#cdp-none").hidden = shown > 0;
    }
    q.addEventListener("input", apply);
    vid.addEventListener("change", apply);
    jumpSel.addEventListener("change", function () {
      if (!jumpSel.value) return;
      q.value = ""; vid.checked = false; apply();
      var el = document.getElementById(jumpSel.value);
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); el.classList.add("cdp-hit"); setTimeout(function () { el.classList.remove("cdp-hit"); }, 1600); }
      jumpSel.value = "";
    });
    apply();
  }

  function fail() {
    root.innerHTML = '<p class="cdp-none">The list could not be loaded. Please refresh the page, or contact VoIP Technical Support.</p>';
  }

  if (window.CD_PBX) return render(window.CD_PBX);
  var src = root.getAttribute("data-src");
  if (!src) return fail();
  var s = document.createElement("script");
  s.src = src + (src.indexOf("?") < 0 ? "?" : "&") + "v=" + Math.floor(Date.now() / 300000); // new content within 5 minutes
  s.onload = function () { window.CD_PBX ? render(window.CD_PBX) : fail(); };
  s.onerror = fail;
  document.head.appendChild(s);
})();
